import React from 'react';
import { ResultsFeedbackPanel } from './sidebar/ResultsFeedbackPanel';
import type { FeedbackContextData } from '../../lib/types/feedback';
import { useFeedbackModal } from '../../contexts/FeedbackModalContext';

interface ResultsFeedbackModalProps {
  isOpen: boolean;
  onClose: () => void;
  contextData: FeedbackContextData;
}

export const ResultsFeedbackModal: React.FC<ResultsFeedbackModalProps> = ({
  isOpen,
  onClose,
  contextData,
}) => {
  const { closeModal } = useFeedbackModal();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[10000] flex items-center justify-center px-4 sm:px-6">
      <div
        className="absolute inset-0 bg-slate-900/70 transition-opacity"
        aria-hidden
        onClick={onClose}
      />

      <div className="relative w-full max-w-xl mx-auto">
        <div className="relative bg-slate-900 border border-slate-700 rounded-2xl shadow-2xl overflow-hidden">
          <div className="flex items-center justify-between px-4 py-3 border-b border-slate-700/80">
            <div className="space-y-0.5">
              <p className="text-[10px] uppercase tracking-[0.12em] text-slate-300">Feedback</p>
              <h2 className="text-lg font-semibold text-white">Beta feedback</h2>
            </div>
            <button
              onClick={onClose}
              aria-label="Close feedback"
              className="p-2 rounded-lg text-slate-300 hover:text-white hover:bg-slate-800 transition-colors"
            >
              <svg className="w-5 h-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2}>
                <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>
          </div>

          <div className="p-4 sm:p-5">
            <ResultsFeedbackPanel
              comparisonId={contextData.comparisonId}
              modelSettings={contextData.modelSettings}
              correlationId={contextData.correlationId}
              onSuccess={closeModal}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
